import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconStatusComponent } from '@shared/components/icon-status/icon-status.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-icon-status',
	imports: [SharedModule, IconStatusComponent, UiCodeBlockComponent],
	templateUrl: './ui-icon-status.component.html',
	styleUrl: './ui-icon-status.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiIconStatusComponent {
	generateCode(attrs: { status: string; label?: string; iconRight?: boolean }): string {
		let code = '<app-icon-status';
		code += `\n    status="${attrs.status}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.iconRight) code += `\n    [iconRight]="true"`;
		code += '\n/>';
		return code;
	}
}
